import type { IconName } from '@customerio/pluma-icons';

export type MessagingUseCaseOption = {
  value: string;
  label: string;
  /**
   * Rendered one line each. An empty line becomes a non-breaking space so every
   * card's description occupies the same two lines.
   */
  descriptionLines: string[];
  icon: IconName;
};

export const MESSAGING_USE_CASES: MessagingUseCaseOption[] = [
  {
    value: 'transactional',
    label: 'Transactional messages',
    descriptionLines: ['Receipts, confirmations,', 'password reset'],
    icon: 'transactional-api',
  },
  {
    value: 'automated_workflows',
    label: 'Automated workflows',
    descriptionLines: ['Trigger-based automations', ''],
    icon: 'campaigns',
  },
  {
    value: 'newsletters',
    label: 'One-time sends',
    descriptionLines: ['Updates across email, push, or', 'in-app'],
    icon: 'broadcast',
  },
  {
    value: 'dynamic_segmentation',
    label: 'Dynamic segmentation',
    descriptionLines: ['Behavior-based segmentation', ''],
    icon: 'segment',
  },
];
